import { IAgentFilterItem } from "..";

import { AccountCircle } from "@livechat/design-system-icons";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

export const responseAuthorFilterConfig: IFilterConfig = {
  title: "Response author",
  icon: AccountCircle,
  multiple: false,
  getFilterLabelValues: (filterValues: string[] | null, agents: IAgentFilterItem[]): IFilterLabelValue[] => {
    if (filterValues === null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    const responseAuthor = agents.find(agent => agent.id === filterValues[0]);
    if (responseAuthor == null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    return [
      {
        key: filterValues[0],
        label: `First response by ${responseAuthor.name}`,
      },
    ];
  },
};
